import { useIntl } from 'react-intl';
import { Dialog, Typography } from '@rossum/ui/material';
import ActionDialog from '../../../components/UI/ActionDialog';
import ActionDialogActions from '../../../components/UI/ActionDialog/ActionDialogActions';

type MoveToReviewDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const MoveToReviewDialog = ({
  open,
  onClose,
  onConfirm,
}: MoveToReviewDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { width: 480, minHeight: 220, position: 'fixed' },
        elevation: 2,
      }}
      onClose={onClose}
      sx={{ transition: 'smooth' }}
    >
      <ActionDialog
        dialogTitle={intl.formatMessage({
          id: 'components.modal.moveToReview.title',
        })}
        onCancel={onClose}
        dialogColor="primary"
        dataCy="close-move-to-review-dialog-btn"
        dialogActions={
          <ActionDialogActions
            confirmButtonProps={{
              onClick: () => {
                onConfirm();
                onClose();
              },
              color: 'primary',
            }}
            confirmButtonText={intl.formatMessage({
              id: 'components.modal.moveToReview.confirm',
            })}
            cancelButtonText={intl.formatMessage({
              id: 'components.modal.moveToReview.cancel',
            })}
            dataCyConfirm="move-to-review-confirm-button"
            dataCyCancel="move-to-review-cancel-button"
          />
        }
      >
        <Typography variant="body1">
          {intl.formatMessage({
            id: 'components.modal.moveToReview.text',
          })}
        </Typography>
      </ActionDialog>
    </Dialog>
  );
};
